import React from 'react';
import { createRoot } from 'react-dom/client';

import { MantineProvider, createTheme } from '@mantine/core';
import { Notifications } from '@mantine/notifications';

import { AuthProvider } from './contexts/AuthContext';
import Router from './Router';

import '@mantine/core/styles.css';
import '@mantine/notifications/styles.css';
import '@mantine/dates/styles.css';
import '@mdxeditor/editor/style.css';

// Get the root element
const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

// Create a root
const root = createRoot(rootElement);

// Create theme with dark mode
const theme = createTheme({
  primaryColor: 'blue',
  fontFamily: 'Roboto, sans-serif',
  defaultRadius: 'md'
});

// Render the app
root.render(
  <MantineProvider theme={theme}>
    <Notifications position="top-right" />
    <AuthProvider>
      <Router />
    </AuthProvider>
  </MantineProvider>
);
